// Module
var code = `<template> <div class="partial-third-party-prefetch row col-12"> <lookup-control class="col-12 col-sm-6 col-md-3 margin-bottom col-gutter" parameters="1" label="Data Type" parameters="1" query="RefinitivDataTypes" placeholder="Select" selected-value.two-way="meta.dataTypeId" readonly.to-view="isReadOnly"></lookup-control> </div> </template>`;
// Exports
module.exports = code;